import { useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { usePreviewStore } from './previewStore'

// Origens do ERP autorizadas a entregar a sessao de preview.
const ALLOWED_ERP_ORIGINS = [
  import.meta.env.VITE_ERP_URL,
  'https://org.infosaas.ai',
  'http://localhost:5174',
].filter(Boolean)

function isPreviewRequested() {
  if (typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).get('preview') === '1'
}

/**
 * Ponte do modo preview. Quando o portal e aberto com `?preview=1` dentro de um
 * iframe do ERP:
 *  1. avisa o pai ("portal-preview-ready"), repetindo ate receber a sessao;
 *  2. ao receber "portal-preview-session" (token_hash) de uma origem confiavel,
 *     faz verifyOtp() e minta a propria sessao read-only.
 * Nao renderiza nada.
 */
export function PreviewBridge() {
  const setPreview = usePreviewStore((s) => s.setPreview)
  const setSessionReady = usePreviewStore((s) => s.setSessionReady)

  useEffect(() => {
    if (!isPreviewRequested()) return
    setPreview(true)

    let cancelled = false
    // Guard SINCRONO: o token_hash e de uso unico e o ERP responde a cada ping
    // com um token novo. Sem travar antes do await, varios verifyOtp rodam em
    // paralelo e todos menos um dao 403. handled garante uma tentativa por vez.
    let handled = false

    async function onMessage(e) {
      if (!ALLOWED_ERP_ORIGINS.includes(e.origin)) return
      if (e.data?.type !== 'portal-preview-session') return
      if (handled) return
      const { token_hash } = e.data
      if (!token_hash) return
      handled = true // trava antes do await
      // O portal minta a propria sessao com a sua anon key (evita 403 por
      // divergencia de chave ao receber tokens prontos da edge function).
      const { error } = await supabase.auth.verifyOtp({ token_hash, type: 'magiclink' })
      if (cancelled) return
      if (error) {
        // Token falhou; libera pra tentar com o proximo ping/token.
        handled = false
        return
      }
      setSessionReady(true)
    }

    window.addEventListener('message', onMessage)

    // Pede a sessao ao pai. Repete algumas vezes caso o listener do ERP ainda
    // nao esteja montado quando o iframe carrega. O ping nao carrega segredo.
    let tries = 0
    const ping = () => {
      if (cancelled || handled || usePreviewStore.getState().sessionReady) return
      window.parent?.postMessage({ type: 'portal-preview-ready' }, '*')
      if (++tries < 10) setTimeout(ping, 400)
    }
    ping()

    return () => {
      cancelled = true
      window.removeEventListener('message', onMessage)
    }
  }, [setPreview, setSessionReady])

  return null
}
